import triggerDownload from "../../helpers/triggerDownload";

export default (filters, ids = []) => async (dispatch, getState, { api }) => {
  try {
    const response = await api.factoring.getFundingRequestReceivablesExport(
      filters,
      ids
    );
    triggerDownload(response.download_url);
  } catch (e) {
    throw e;
  }
};
